/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/dashboard',
    name: 'Dashboard',
    icon: 'HomeIcon',
    i18n: 'Dashboard'
  },
  {
    url: '/user-company-mappings',
    name: 'Management Mapping',
    slug: 'user-company-mappings',
    icon: 'GitMergeIcon'
  },
  {
    url: '/balance-reconciliation',
    name: 'Rekonsiliasi Saldo',
    slug: 'balance-reconciliation',
    icon: 'CheckSquareIcon'
  },
  {
    header: 'Cashflow Management',
    icon: 'LayersIcon',
    items: [
      {
        url: '/cashbook/mixed-cash',
        name: 'Buku Kas',
        slug: 'cash-book',
        icon: 'BookIcon',
        submenu: [
          { url: '/cashbook/petty-cash', name: 'Petty Cash', slug: 'petty-cash' },
          { url: '/cashbook/big-cash', name: 'Big Cash', slug: 'big-cash' },
          { url: '/cashbook/mixed-cash', name: 'Mixed Cash', slug: 'mixed-cash' }
        ]
      },
      {
        url: '/cash-book-temporary',
        name: 'Bon Sementara',
        slug: 'cash-book-temporary',
        icon: 'RepeatIcon'
      },
      {
        url: '/bank',
        name: 'Bank',
        slug: 'bank',
        icon: 'CreditCardIcon'
      }
    ]
  },
  {
    header: 'Input Data',
    icon: 'PackageIcon',
    i18n: 'InputData',
    items: [
      {
        url: '/accounts-number',
        name: 'Account Number',
        slug: 'accounts-number',
        icon: 'BookIcon',
        i18n: 'Accounts'
      },
      {
        url: '/manage-coa',
        name: 'Manage COA',
        slug: 'manage-coa',
        icon: 'GitMergeIcon'
      },
      {
        url: '/journal-vouchers',
        name: 'Journal Voucher',
        slug: 'journal-vouchers',
        icon: 'FileTextIcon',
        i18n: 'JournalVoucher'
      },
      {
        url: '/report-settings',
        name: 'Report Setting',
        slug: 'report-settings',
        icon: 'SettingsIcon',
        i18n: 'ReportSetting'
      }
    ]
  },
  {
    header: 'View / Print',
    icon: 'PackageIcon',
    i18n: 'ViewPrint',
    items: [
      {
        url: '/general-ledgers',
        name: 'General Ledger',
        slug: 'general-ledgers',
        icon: 'BookIcon',
        i18n: 'GeneralLedger'
      },
      {
        url: '/financial-statements',
        name: 'Financial Statement',
        slug: 'financial-statements',
        icon: 'FileTextIcon',
        i18n: 'FinancialReport'
      },
      {
        url: '/income-statements',
        name: 'Income Statement',
        slug: 'income-statements',
        icon: 'FileTextIcon',
        i18n: 'IncomeReport'
      }
    ]
  }
  // {
  //   header: 'LAINNYA',
  //   icon: 'PackageIcon',
  //   i18n: 'Other',
  //   items: [
  //     {
  //       url: '/account',
  //       name: 'Account',
  //       slug: 'account',
  //       icon: 'UserIcon',
  //       i18n: 'SettingAccount'
  //     },
  //     {
  //       url: '/change-password',
  //       name: 'ChangePassword',
  //       slug: 'change-password',
  //       icon: 'LockIcon',
  //       i18n: 'ChangePassword'
  //     }
  //   ]
  // }
]

